var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9584 10.9583C18.4416 10.9583 18.8334 11.3501 18.8334 11.8333V21.1667H28.1667C28.6097 21.1667 28.9758 21.4958 29.0337 21.9229L29.0417 22.0417C29.0417 27.8406 24.3407 31.9583 18.5417 31.9583C12.7427 31.9583 8.04169 27.2573 8.04169 21.4583C8.04169 15.6593 12.1594 10.9583 17.9584 10.9583ZM21.4584 8.04166C27.2573 8.04166 31.9584 12.7427 31.9584 18.5417C31.9584 19.0249 31.5666 19.4167 31.0834 19.4167H21.4584C20.9751 19.4167 20.5834 19.0249 20.5834 18.5417V8.91666C20.5834 8.43341 20.9751 8.04166 21.4584 8.04166Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.a79593d64d1e7ab95b1ab15d04ae5b03.svg";
export { ForwardRef as ReactComponent };